module.exports = __webpack_public_path__ + "static/img/banner1.723a563.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/image/banner1.png
// module id = qjvi
// module chunks = 1